<app-tooltip
    *ngIf="slot.label"
    tooltipPosition="top"
    type="info"
    class="label-tooltip"
    record="{{ slot.label }}"
>
</app-tooltip>
<span class="name">{{ slot?.name }}</span>
<div *ngIf="hasSettings">
    <span
        class="fa fa-cog settings"
        (click)="onSettingsClick($event)"
    ></span>
</div>

<app-context-menu
    [contextMenuItems]="contextMenuItems"
></app-context-menu>
